module.exports = __webpack_public_path__ + "static/media/youtube.d636ebff.png";